import { ArrowUp, Instagram, Facebook, Youtube } from 'lucide-react';
import { Logo } from './Logo';
import { NAV_LINKS, CONTACT, SOCIAL } from '../data/content';
import { scrollToId, scrollToTop } from '../lib/scroll';

const SOCIAL_ICONS = { instagram: Instagram, facebook: Facebook, youtube: Youtube };

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer-container" className="overflow-hidden bg-espresso">
      <div className="mx-auto max-w-7xl px-5 pb-8 pt-20 md:px-10">
        <div className="flex flex-col justify-between gap-12 md:flex-row">
          <div>
            <Logo variant="light" />
            <p className="mt-6 max-w-xs text-sm font-light leading-relaxed text-sand/70">
              Custom homes, full-scale renovations and remodeling — built to a craftsman's standard.
            </p>
          </div>
          <nav className="flex flex-col gap-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Explore</p>
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => scrollToId(l.id)}
                className="text-left text-sm text-sand transition-colors hover:text-gold"
              >
                {l.label}
              </button>
            ))}
          </nav>
          <div className="flex flex-col gap-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Reach Us</p>
            <span data-testid="footer-email" className="text-sm text-sand">{CONTACT.email}</span>
            <div className="mt-2 flex gap-3">
              {SOCIAL.map((s) => {
                const Icon = SOCIAL_ICONS[s.id];
                return (
                  <a
                    key={s.id}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-social-${s.id}`}
                    aria-label={`Invicto Homes on ${s.label}`}
                    className="flex h-10 w-10 items-center justify-center border border-gold/30 text-gold transition-all duration-300 hover:bg-gold hover:text-espresso"
                  >
                    <Icon size={16} />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <h2
          data-testid="footer-brand-title"
          className="mt-16 select-none text-center font-serif text-[24vw] font-light leading-[0.85] text-[#3A322A] md:text-[19vw]"
        >
          INVICTO
        </h2>

        <div className="mt-4 flex flex-col items-center justify-between gap-4 border-t border-gold/10 pt-6 md:flex-row">
          <p className="text-xs text-sand/50">© {year} Invicto Homes Inc. All rights reserved.</p>
          <button
            data-testid="footer-back-to-top-button"
            onClick={scrollToTop}
            className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-sand transition-colors hover:text-gold"
          >
            Back to top <ArrowUp size={13} />
          </button>
        </div>
      </div>
    </footer>
  );
};
